'use strict';

angular.module('threeViewer.directives', ['threeViewer.services'])

  .directive('threeViewport', ['SceneService', 'ModelFactory', 'ModelDataService', 'CameraSetup', function (SceneService, ModelFactory, ModelDataService, CameraSetup) {
      return {
          restrict: "AE",
          scope: {
            update: '=',
            loaded: '=',
            modelId: '=',
            model3d: '=',
            set3d: '=',
            useOrbitControls: '='
          },
          controller: ['$scope','$rootScope','$element',function ($scope, $rootScope, $element) {

              var firstRun = true;

              $scope.model3d = Array.isArray($scope.model3d) ? $scope.model3d : [$scope.model3d];

              $scope.modelsLoaded = 0;

              $scope.$watch("modelsLoaded",function(val) {
                $scope.loaded.complete = val < $scope.model3d.length ? false : true;
                $scope.loaded.progress = $scope.modelsLoaded;
                $scope.loaded.percent = Math.round(val * 100 / $scope.model3d.length);
              });

              const THREE = $rootScope.THREE;
              const OrbitControls = $rootScope.OrbitControls;
              const OBJLoader = $rootScope.OBJLoader;

              var scene = new THREE.Scene();
              scene.background = new THREE.Color( parseInt($scope.set3d.colorBG) );

              const camSet = $scope.set3d.camSetup;

              var cam = new THREE.PerspectiveCamera(camSet.v, camSet.ax / camSet.ay, camSet.n, camSet.f);

              var renderer,material,geometry,mesh;

              $element.ready(function() {
                init($element);
                $scope.set3d.lights.forEach(function(v,i) {
                  loadLight(v, scene);
                })
                animate();
              });

              function init(el) {

                  // Add the camera
                  cam.position.set(0, 0, $scope.set3d.camZ);
                  cam.aspect = $scope.set3d.aspect;

                  // create the renderer
                  renderer = new THREE.WebGLRenderer({ antialias: true });
                  renderer.setSize(el[0].offsetWidth, el[0].offsetWidth * (1 / $scope.set3d.aspect));
                  renderer.setClearColor(new THREE.Color($scope.set3d.colorBG), $scope.set3d.opacityBG);
                  rendererResize(el);
                  // set up the controls with the camera and renderer
                  if($scope.useOrbitControls.enabled) {
                    $scope.ctrls = new OrbitControls(cam, renderer.domElement);
                    $scope.ctrls.autoRotate = $scope.set3d.autoRotate;
                    $scope.ctrls.autoRotateSpeed = $scope.set3d.autoRotateSpeed;
                    $scope.ctrls.rotateSpeed = $scope.set3d.rotateSpeed;
                    $scope.ctrls.enableDamping = $scope.set3d.enableDamping;
                    $scope.ctrls.dampingFactor = $scope.set3d.dampingFactor;
                    $scope.ctrls.enablePan = $scope.set3d.enablePan;
                    $scope.ctrls.maxDistance = $scope.set3d.maxDistance;
                    $scope.ctrls.minDistance = $scope.set3d.minDistance;
                    $scope.ctrls.update();
                  }
                  // add renderer to DOM
                  el[0].appendChild(renderer.domElement);

                    scene.add(cam);

                  // handles resizing the renderer when the window is resized
                  window.addEventListener('resize', rendererResize, false);
              }

              function animate() {
                  requestAnimationFrame(animate);
                  renderer.render(scene, cam);
                  if($scope.useOrbitControls.enabled) {
                    $scope.ctrls.update();
                  };
              }

              function rendererResize(force) {
                console.log("renderer width: "+$element[0].offsetWidth);
                var canvas = renderer.domElement;
                var width = $element[0].offsetWidth;
                var height = $element[0].offsetHeight;

                if (force || canvas.width !== width || canvas.height !== height) {
                  renderer.setSize(width, height);
                  var camZ = width < 450 ? $scope.set3d.camPhoneZ : $scope.set3d.camZ;
                  cam.position.set(0, 0, camZ);
                  cam.aspect = width / height;
                  cam.updateProjectionMatrix();
                }
              }

              var loadLight = function(light, scene) {
                if(typeof scene.getObjectByName( light.name ) == 'undefined') {
                  switch(light.type) {
                    case "Ambient":
                      console.log("Add Ambient Light");
                      console.log(light);
                      var lx = new THREE.AmbientLight( parseInt(light.color), light.intensity ); // soft white light
                      lx.name = light.name;
                      scene.add( lx );
                      break;
                    case "Directional":
                      console.log("Add Directional Light");
                      console.log(light);
                      var lx = new THREE.DirectionalLight( parseInt(light.color), light.intensity ); // soft white light
                      lx.name = light.name;
                      lx.position.set(light.position.x, light.position.y, light.position.z)
                      scene.add( lx );
                      break;
                    default:
                      //
                  }
                }
              }

              $scope.addModel = function (scene, args) {

                  var zMesh = {};
                  var visible = args.visible;

                  //console.log(args.name+' opacity: '+opacity);
                  const textureLoader = new THREE.TextureLoader();
                  var texture = textureLoader.load( 'obj/blue_texture_01sm.jpg' );
                  texture.encoding = THREE.sRGBEncoding;
                  texture.anisotropy = 16;

                  ModelDataService.getData(args.path).then(function (dataResponse) {

                      var model=(args.path);

                      var manager = new THREE.LoadingManager();

                      manager.onStart = function ( item, loaded, total ) {
                          //$rootScope.load3D.status = args.name+' loading';
                          //$rootScope.load3D.items = loaded;
                          console.log('Start Load Model '+$scope.modelId+' '+args.name);
                        console.log(item, loaded, total);
                      };
                      manager.onProgress = function (item, loaded, total) {
                          //$rootScope.load3D.items = loaded;
                        console.log(item, loaded, total);
                      };
                      manager.onLoad = function () {
                        $scope.$apply(function() {
                          //$scope.modelsLoaded ++;
                          //zMesh.visible = visible;
                          console.log('Loaded Model '+$scope.modelId+' '+args.name);
                          //console.log(zMesh.name+' '+args.visible+' '+visible+' '+zMesh.visible);
                        });
                        //scene.add(zMesh);
                        console.log(args.name+' loaded');
                      };
                      manager.onError = function () {
                        //  $rootScope.load3D.status = 'load error';
                        console.log('there has been an error');
                      };

                      //var loader = new THREE.JSONLoader(manager);
                      var loader = new OBJLoader(manager);

                    	var initMesh = function( obj)	{
                        console.log($scope.modelId+' '+args.name+' initMesh');
                        zMesh = obj;

                        zMesh.shading = THREE.SmoothShading;
                    		zMesh.overdraw = true;
                    		zMesh.needsUpdate = true

                        var name = args.name || 'No Name';
                        var pos = args.pos || {x:0,y:-150,z:0};
                        var rot = args.rot || {x:23.5,y:0,z:0};
                        var scale = args.scale || 1;
                        var color = args.color || "0xFFFFFF";
                        var opacity = args.opacity == 0 ? 0 : args.opacity;
                        var wireframe = args.wireframe || false;
                        var bump = args.bump || false;
                        var normal = args.normal || false;

                        zMesh.name = name;
                        zMesh.position.set(pos.x, pos.y, pos.z);
                        zMesh.rotation.set(rot.x, rot.y, rot.z);
                        zMesh.scale.set(scale,scale,scale);
                        zMesh.visible = false;

                        zMesh.traverse( function(child) {
                          if ( child instanceof THREE.Mesh ) {
                            console.log(child.name);
                            //console.log(child);
                            if(child.material) {
                              if(child.name.indexOf('Eye') < 0) {
                                child.material.shininess = 90;
                                //child.material.map = texture;
                                if(bump) {
                                  console.log('applying bump to '+child.name);
                                  child.material.bumpMap = new THREE.TextureLoader(bump);
                                  child.material.bumpScale = 5;
                                  child.material.needsUpdate = true;
                                  console.log(child.material);
                                };
                                if(normal) {
                                  console.log('applying normal to '+child.name);
                                  //var nmap = new THREE.TextureLoader(normal);
                                  child.material.normalMap = new THREE.TextureLoader(normal);
                                  //child.material.normalMap = nmap;
                                  //child.material.bumpScale = 5;
                                  child.material.needsUpdate = true;
                                  console.log(child.material);
                                };
                              }
                              //child.material.transparent = true;
                              //child.material.opacity = opacity;
                              //child.material.wireframe = wireframe;

                              //console.log(child.name+'material opacity: '+child.material.opacity);
                              if(child.material.color) {
                                child.material.color.set(parseInt(color));
                              };
                            };
                          };
                        });
                        $scope.modelsLoaded ++;
                        zMesh.visible = visible;
                        scene.add(zMesh);

                    	};

                      //if(typeof scene.getObjectByName( name ) == 'undefined') {
      		              loader.load( model, initMesh );
                      //}

                  });

              }

              var clearMeshes = function() {
                console.log('CLEARING SCENE');
                for (let i = scene.children.length - 1; i >= 0; i--) {
                    console.log(scene.children[i].id+' '+scene.children[i].name+' '+scene.children[i].type);
                    if(scene.children[i].type === "Group") {
                      for (let j = scene.children[i].children.length - 1; j >= 0; j--) {
                        if(scene.children[i].children[j].geometry) {
                          scene.children[i].children[j].geometry.dispose();
                        };
                        if(scene.children[i].children[j].material) {
                          //scene.children[i].children[j].material.dispose();
                        };
                      }
                      scene.remove(scene.children[i]);
                    }
                  }
              }

              $scope.$watch(function() {return $scope.update}, function(val) {

                if(!val) {
                  return;
                };

                if(firstRun) {
                  firstRun = false;
                  $scope.update = false;
                  return;
                };

                clearMeshes();
                $scope.loaded = {complete: false, progress: 0};
                $scope.model3d = Array.isArray($scope.model3d) ? $scope.model3d : [$scope.model3d];
                $scope.model3d.map(function(model) {
                  $scope.addModel(scene, model);
                });
                $scope.update = false;
              });

              $scope.$watch(function() {return $scope.model3d}, function(val,oldVal) {
                for(var i=0;i<val.length;i++) {
                  if(!angular.equals(val[i],oldVal[i])) {
                    if(scene.getObjectByName( val[i].name )) {
                      $scope.updateMesh(val[i]);
                    };
                  }
                };
              },true);

              $scope.updateMesh = function(m) {
                console.log(m);
                //for(var i=0;i<$scope.model3d.length;i++) {

                  if(typeof scene.getObjectByName(m.name ) == 'undefined') {
                    console.log($scope.model3d[i].name+' is undefined');
                    return false;
                  };
                  var zm = scene.getObjectByName(m.name );

                  var name =m.name || 'No Name';
                  var pos =m.pos || {x:0,y:-150,z:0};
                  var rot =m.rot || {x:23.5,y:0,z:0};
                  var scale =m.scale || 1;
                  var color =m.color || "0xFFFFFF";
                  var visible =m.visible;
                  var opacity =m.opacity == 0 ? 0 :m.opacity;
                  var wireframe =m.wireframe || false;

                  console.log(m.name+' opacity: '+ opacity);

                  zm.name = name;
                  zm.visible = visible;
                  zm.position.set(pos.x, pos.y, pos.z);
                  zm.rotation.set(rot.x, rot.y, rot.z);
                  zm.scale.set(scale,scale,scale);

                  zm.traverse( function(child) {
                    if ( child instanceof THREE.Mesh ) {
                      //console.log(child.name);
                      //console.log(child);
                      if(child.material) {
                        if(typeof child.material.length !== 'undefined') {
                          for(var j=0;j<child.material.length;j++) {
                            //console.log(child.name+' opacity: '+child.material[j].opacity);
                            child.material[j].opacity = opacity;
                            //console.log(child.name+' opacity: '+child.material[j].opacity);
                            child.material[j].wireframe = wireframe;
                            if(child.material[j].color) {
                              //child.material[j].color.set(parseInt(color));
                            }
                          }
                        }
                        else {
                          console.log(child.name+' is not array');
                          child.material.opacity = opacity;
                          child.material.wireframe = wireframe;
                          if(child.material.color) {
                            //child.material.color.set(parseInt(color));
                          }
                        }
                      }
                    }
                  });


              };



              $scope.model3d.map(function(model) {
                if(typeof scene.getObjectByName(model.name ) == 'undefined') {
                  $scope.addModel(scene, model);
                }
              });

          }]
      }
  }])

  .directive('fbxViewport', ['SceneService', 'ModelFactory', 'ModelDataService', 'CameraSetup', function (SceneService, ModelFactory, ModelDataService, CameraSetup) {
      return {
          restrict: "AE",
          scope: {
            curState: '=',
            update: '=',
            loaded: '=',
            modelId: '=',
            model3d: '=',
            set3d: '=',
            useOrbitControls: '='
          },
          controller: ['$scope','$rootScope','$element',function ($scope, $rootScope, $element) {

              var firstRun = true;

              $scope.model3d = Array.isArray($scope.model3d) ? $scope.model3d : [$scope.model3d];

              $scope.modelsLoaded = 0;

              $scope.$watch("modelsLoaded",function(val) {
                $scope.loaded.complete = val < $scope.model3d.length ? false : true;
                $scope.loaded.progress = val;
                $scope.loaded.percent = Math.round(val * 100 / $scope.model3d.length);
              });

              const THREE = $rootScope.THREE;
              const OrbitControls = $rootScope.OrbitControls;
              const FBXLoader = $rootScope.FBXLoader;

              var scene = new THREE.Scene();
              scene.background = new THREE.Color( parseInt($scope.set3d.colorBG) );

              const camSet = $scope.set3d.camSetup;

              var cam = new THREE.PerspectiveCamera(camSet.v, camSet.ax / camSet.ay, camSet.n, camSet.f);

              var renderer,material,geometry,mesh;

              $element.ready(function() {
                init($element);
                $scope.set3d.lights.forEach(function(v,i) {
                  loadLight(v, scene);
                })
                animate();
              });

              function init(el) {

                  // Add the camera
                  cam.position.set(0, 0, $scope.set3d.camZ);
                  cam.aspect = $scope.set3d.aspect;

                  // create the renderer
                  renderer = new THREE.WebGLRenderer({ antialias: true });
                  renderer.setSize(el[0].offsetWidth, el[0].offsetWidth * (1 / $scope.set3d.aspect));
                  renderer.setClearColor(new THREE.Color($scope.set3d.colorBG), $scope.set3d.opacityBG);
                  rendererResize(el);
                  // set up the controls with the camera and renderer

                  if($scope.useOrbitControls.enabled) {
                    $scope.ctrls = new OrbitControls(cam, renderer.domElement);
                    $scope.ctrls.autoRotate = $scope.set3d.autoRotate;
                    $scope.ctrls.autoRotateSpeed = $scope.set3d.autoRotateSpeed;
                    $scope.ctrls.rotateSpeed = $scope.set3d.rotateSpeed;
                    $scope.ctrls.enableDamping = $scope.set3d.enableDamping;
                    $scope.ctrls.dampingFactor = $scope.set3d.dampingFactor;
                    $scope.ctrls.enablePan = $scope.set3d.enablePan;
                    $scope.ctrls.maxDistance = $scope.set3d.maxDistance;
                    $scope.ctrls.minDistance = $scope.set3d.minDistance;
                    $scope.ctrls.update();
                  }
                  // add renderer to DOM
                  el[0].appendChild(renderer.domElement);

                    scene.add(cam);

                  // handles resizing the renderer when the window is resized
                  window.addEventListener('resize', rendererResize, false);
              }

              function animate() {
                  requestAnimationFrame(animate);
                  renderer.render(scene, cam);
                  if($scope.useOrbitControls.enabled) {
                    $scope.ctrls.update();
                  };
              }

              function rendererResize(force) {
                console.log("renderer width: "+$element[0].offsetWidth);
                var canvas = renderer.domElement;
                var width = $element[0].offsetWidth;
                var height = $element[0].offsetHeight;

                if (force || canvas.width !== width || canvas.height !== height) {
                  renderer.setSize(width, height);
                  var camZ = width < 450 ? $scope.set3d.camPhoneZ : $scope.set3d.camZ;
                  cam.position.set(0, 0, camZ);
                  cam.aspect = width / height;
                  cam.updateProjectionMatrix();
                }
              }

              var loadLight = function(light, scene) {
                if(typeof scene.getObjectByName( light.name ) == 'undefined') {
                  switch(light.type) {
                    case "Ambient":
                      //console.log("Add Ambient Light");
                      //console.log(light);
                      var lx = new THREE.AmbientLight( parseInt(light.color), light.intensity ); // soft white light
                      lx.name = light.name;
                      scene.add( lx );
                      break;
                    case "Directional":
                      //console.log("Add Directional Light");
                      //console.log(light);
                      var lx = new THREE.DirectionalLight( parseInt(light.color), light.intensity ); // soft white light
                      lx.name = light.name;
                      lx.position.set(light.position.x, light.position.y, light.position.z)
                      scene.add( lx );
                      break;
                    default:
                      //
                  }
                }
              };

              $scope.addModel = function (scene, args) {

                  var zMesh = {};
                  var visible = args.visible;
                  var texture = null;

                  if(args.texture && args.texture !== null) {
                    const textureLoader = new THREE.TextureLoader();
                    texture = textureLoader.load( args.texture );
                    texture.encoding = THREE.sRGBEncoding;
                    texture.anisotropy = 16;
                  }

                  ModelDataService.getData(args.path).then(function (dataResponse) {

                      var model=(args.path);

                      var loader = new FBXLoader();

                      loader.load( model, function ( object ) {

                        zMesh = object;

                          var name = args.name || 'No Name';
                          var pos = args.pos || {x:0,y:-150,z:0};
                          var rot = args.rot || {x:23.5,y:0,z:0};
                          var scale = args.scale || 1;
                          var color = args.color || "0xFFFFFF";
                          var emissive =args.emissive || "0x000000";
                          var shininess =args.shininess || 30;
                          var opacity = args.opacity == 0 ? 0 : args.opacity;
                          var wireframe = args.wireframe || false;

                          zMesh.name = name;
                          zMesh.position.set(pos.x, pos.y, pos.z);
                          zMesh.rotation.set(rot.x, rot.y, rot.z);
                          zMesh.scale.set(scale,scale,scale);

                          zMesh.traverse( function(child) {
                            if ( child.isMesh ) {

                              if(child.material) {
                                if(child.material.name && (child.material.name.indexOf("Material")>-1 || child.material.name.indexOf("material")>-1)) {
                                  //console.log('SETTING COLOR OF '+child.material.name+' to '+color);
                                  child.material.vertexColors = false;
                                  child.material.map = texture;
                                  child.material.emissive = new THREE.Color(parseInt(emissive));
                                  child.material.emissiveIntensity = 1;
                                  child.material.shininess = shininess;
                                  child.material.color.set(parseInt(color));
                                  child.material.needsUpdate = true;

                                  //console.log(child.material);

                                };

                              };

                            };
                          });

                          $scope.$apply(function(){
                            $scope.modelsLoaded++;
                            zMesh.visible = visible;
                            //console.log("LOADED "+$scope.modelsLoaded+' '+zMesh.id+' '+zMesh.name+' vis: '+zMesh.visible);
                            scene.add(zMesh);
                          })

                          //scene.add(zMesh);

                        }, undefined, function ( e ) {

                          console.error( e );

                      });

                  });
              };

              var clearMeshes = function() {
                console.log('CLEARING SCENE');
                for (let i = scene.children.length - 1; i >= 0; i--) {
                    console.log(scene.children[i].id+' '+scene.children[i].name+' '+scene.children[i].type);
                    if(scene.children[i].type === "Group") {
                      for (let j = scene.children[i].children.length - 1; j >= 0; j--) {
                        if(scene.children[i].children[j].geometry) {
                          scene.children[i].children[j].geometry.dispose();
                        };
                        if(scene.children[i].children[j].material) {
                          /*
                          try {
                            scene.children[i].children[j].material.dispose();
                          }
                          catch(err) {
                            console.log(scene.children[i].children[j].material);
                          }
                          */
                        };
                      }
                      scene.remove(scene.children[i]);
                    }
                  }
              }

              $scope.updateMesh = function(m, init) {

                  if(typeof scene.getObjectByName(m.name ) == 'undefined') {
                    console.log($scope.model3d[i].name+' is undefined');
                    return false;
                  };
                  var zm = init == true ? m : scene.getObjectByName(m.name );

                  var name =m.name || 'No Name';
                  var pos =m.pos || {x:0,y:-150,z:0};
                  var rot =m.rot || {x:23.5,y:0,z:0};
                  var scale =m.scale || 1;
                  var visible =m.visible;
                  var wireframe =m.wireframe || false;

                  zm.name = name;
                  zm.visible = visible;
                  zm.position.set(pos.x, pos.y, pos.z);
                  zm.rotation.set(rot.x, rot.y, rot.z);
                  zm.scale.set(scale,scale,scale);
                  zm.wireframe = wireframe;

              };

              $scope.model3d.map(function(model) {
                if(typeof scene.getObjectByName(model.name ) == 'undefined') {
                  $scope.addModel(scene, model);
                }
              });

              $scope.$watch(function() {return $scope.update}, function(val) {

                if(!val) {
                  return;
                };

                if(firstRun) {
                  firstRun = false;
                  $scope.update = false;
                  return;
                };

                clearMeshes();
                $scope.loaded = {complete: false, progress: 0};
                $scope.modelsLoaded = 0;
                $scope.model3d = Array.isArray($scope.model3d) ? $scope.model3d : [$scope.model3d];
                $scope.model3d.map(function(model) {
                  $scope.addModel(scene, model);
                });
                $scope.update = false;
              });

              $scope.$watch(function() {return $scope.model3d}, function(val,oldVal) {

                for(var i=0;i<val.length;i++) {
                  if(!angular.equals(val[i],oldVal[i])) {
                    if(scene.getObjectByName( val[i].name )) {
                      $scope.updateMesh(val[i], false);
                    };
                  }
                };
              },true);

          }]
      }
  }
  ]);



// WEBPACK FOOTER //
// ./src/app/js/threeDirectives.js